import Circle from "../LogoSVG/Circle";
import optimizerLogo from "../../public/optimizer2.png";
import Arrow from "../LogoSVG/Arrow";

export const listTech = [
  "C#",
  "Python",
  "JavaScript",
  "Unity",
  "Blender API",
  "WebGL",
];

function OptimizerDesktop({ index, hoveredIndex, setHoveredIndex }: any) {
  return (
    <div
      className={`flex flex-row pt-8 pb-6 ${
        hoveredIndex == undefined || hoveredIndex == index ? "" : "opacity-55"
      }`}
      onMouseEnter={() => setHoveredIndex(index)}
      onMouseLeave={() => setHoveredIndex(undefined)}
    >
      <a
        className="flex flex-col items-start "
        href="https://www.optimizer.co.jp/en/"
        target="_blank"
      >
        <p className="w-[180px] items-start text-gray-4">
          Jul 2022 - Feb 2023
        </p>
        <div className="w-[90px] h-[90px] 2xl:h-[110px] 2xl:w-[110px] mt-5 ml-8 overflow-hidden rounded-full">
          <img
            src={optimizerLogo}
            alt="logo"
            className="object-cover w-full h-full"
          />
        </div>
      </a>

      <a
        className="pl-16 2xl:pl-24 w-[700px] 2xl:w-[720px]"
        href="https://www.optimizer.co.jp/en/"
        target="_blank"
      >
        <div
          className="flex flex-row items-center mb-2 font-medium text-[18px]"
          style={{ color: hoveredIndex === index ? "#ebdd86" : "inherit" }}
        >
          <p className="">Software Engineer | Optimizer Inc.</p>
          {/* <Circle className="mx-2 h-1.5 w-1.5 " />
          <p className="mr-4">Optimizer Inc.</p> */}
          <Arrow
            className={`transition-transform duration-250 ease-in-out mb-1 ml-2 ${
              hoveredIndex === index ? "-translate-y-2 translate-x-1" : ""
            }`}
          />
        </div>

        <div className="text-gray-5">
           <div className="flex flex-row mb-1.5">
            <Circle className="mr-3 h-1.5 w-1.5 mt-2" />
            <p className="text-gray-4 w-[600px]">
              Conducted research on transforming 2D images into 3D models
            </p>
          </div>

          <div className="flex flex-row mb-1.5 ">
            <Circle className="mr-3 h-1.5 w-1.5 mt-2" />
            <p className="text-gray-4 w-[600px] ">
              Developed a Japanese 3D e-commerce platform for online purchases and personalized 3D object-building mechanics (90% object-catching accuracy)
            </p>
          </div>
        </div>
      </a>
    </div>
  );
}

export default OptimizerDesktop;
